import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { HeroComponent } from '@shared/lib/components/hero/hero.component';
import { SharedFontAwesomeModule } from '@shared/lib/shared-font-awesome.module';
import { UsanaTranslationsModule } from '@usana/ux/translations';

@NgModule({
  declarations: [HeroComponent],
  imports: [CommonModule, SharedFontAwesomeModule, UsanaTranslationsModule],
  exports: [HeroComponent, UsanaTranslationsModule],
})
export class HeroModule {}
